/* eslint-disable */
export default {
  // ipinyou回调函数
  pyRegisterCvt (_productList) {
    const w = window
    const d = document
    const e = encodeURIComponent
    const g = d.cookie
    const h = g.match(/(^|;)\s*ipycookie=([^;]*)/)
    const i = g.match(/(^|;)\s*ipysession=([^;]*)/)
    let b = location.href
    let c = d.referrer
    let f
    if (w.parent !== w) {
      f = b
      b = c
      c = f
    }
    u = '//stats.ipinyou.com/cvt?a=' +
      e('4hs.qVh.aL6mMbamzngVMaN1KcBWo0') +
      '&c=' + e(h ? h[2] : '') +
      '&s=' + e(i ? i[2].match(/jump\%3D(\d+)/)[1] : '') +
      '&u=' + e(b) + '&r=' + e(c) + '&rd=' + (new Date()).getTime() + '&ProductList=' + e(_productList) +
      '&e='
    const p = new Image()
    p.src = u
  },
  // inmobi回调函数
  OpenMyMd () {
    let imgurl = 'https://d.appsdt.com/download/tracker?goalName=download&appId=e830bb612df644828d048b4b36e0bcd9&src=img&rdm=$rdm'
    const i2 = new Image(0, 0)
    i2.src = imgurl
    i2.onload = function () {
    }
  },
  dspCallBack (szhdbm, pyid) {
    if (szhdbm === 'domob') {
      DomobLanding.monitor.reg({ pyid: pyid })
    } else if (szhdbm === 'ipinyou') {
      this.pyRegisterCvt(pyid)
    } else if (szhdbm === 'inmobi') {
      this.OpenMyMd()
    }
  },
  trackEvent (category, action = 'click', opt_label, opt_value) {
    if (typeof _hmt != "undefined"){
      try {
        _hmt.push(['_trackEvent', category, action, opt_label, opt_value]);
      } catch (error) {
        console.warn(error)
      }
    }
  }
}
